<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchPaymentAccount">
                    <input
                        class="form-control mr-sm-2"
                        type="text"
                        v-model="search.account"
                        placeholder="รหัสบัญชี"/>

                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchPaymentAccount">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button @click="clearFormBeforeModal"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        เพิ่มรหัสบัญชี
                    </button>
                    &nbsp
                    <button type="button" class="btn btn-primary my-2 my-sm-0"
                            @click="printReportExcel">
                        <icon name="file-download"></icon>
                        พิมพ์รายงาน Excel
                    </button>
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสบัญชี</th>
                    <th scope="col">รายการ</th>
                    <th scope="col" width="150px">เพิ่มรายการย่อย</th>
                    <th scope="col" width="150px">แก้ไข</th>
                    <th scope="col" v-if="canViewSuperAdmin">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(data,index) in PaymentAccountTable">
                    <tr>
                        <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                        <td>{{ data.account }}</td>
                        <td>{{ data.name }}</td>
                        <td>
                            <template v-if="data.show==1">
                                <button class="btn btn-info" v-on:click="() => { data.show = 0 }">
                                    <icon name="minus"></icon>
                                    ซ่อน
                                </button>
                            </template>
                            <template v-else>
                                <button class="btn btn-info" v-on:click="() => { data.show = 1}">
                                    <icon name="plus"></icon>
                                    แสดง
                                </button>
                            </template>
                        </td>
                        <td>
                            <button class="btn btn-primary" @click="showBillingPaymentForm(data.id)">
                                <icon name="pencil-alt"></icon>
                                แก้ไข
                            </button>
                        </td>
                        <td v-if="canViewSuperAdmin">
                            <button class="btn btn-danger" @click="showDeleteAccountModal(data.id)">
                                <icon name="trash"></icon>
                                ลบ
                            </button>
                        </td>
                    </tr>
                    <tr v-if="data.show == 1">
                        <td></td>
                        <td colspan="3">
                            <table class="table table-bordered">
                                <tr class="heading-table">
                                    <th>ลำดับ</th>
                                    <th>รหัสบัญชี</th>
                                    <th>รายการย่อย</th>
                                    <th>แก้ไข/ลบ</th>
                                </tr>
                                <template v-if="data.details.length > 0" v-for="(detail,index) in data.details">
                                    <tr>
                                        <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                                        <td>{{ data.account }}.{{ detail.account_number }}</td>
                                        <td>{{ detail.name }}</td>
                                        <td>
                                            <a @click="showAccountDetailsModal(detail.id,data.id)">
                                                <icon name="pencil-alt"></icon>
                                            </a> &nbsp;&nbsp;
                                            <a @click="showDeleteDetailsModal(detail.id)">
                                                <icon name="trash"></icon>
                                            </a>
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        </td>
                        <td colspan="2">
                            <div>
                                <button class="btn btn-danger" @click="showAccountDetailsModal(null,data.id)">
                                    +สร้างรายการย่อย
                                </button>
                            </div>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPage">
            </vue-pagination>
        </div>

        <!--modal account-->
        <b-modal hide-header hide-footer ref="add_account">
            <div class="text-center">
                <add-account-modal account_menu="cost" @submit="saveBillingPaymentForm">
                </add-account-modal>
            </div>
        </b-modal>
        <!--modal account details-->
        <b-modal hide-header hide-footer ref="account_details">
            <div class="text-center">
                <add-account-details-modal @submit="saveAccountDetails">
                </add-account-details-modal>
            </div>
        </b-modal>
        <!--modal delete account -->
        <b-modal hide-header hide-footer ref="delete_account">
            <delete-confirm-modal @submit="deletePaymentAccount"></delete-confirm-modal>
        </b-modal>
        <!--modal delete details-->
        <b-modal hide-header hide-footer ref="delete_account_details">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deleteAccountDetails"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        @click="hideDeleteDetailsModal"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert-primary">{{form_details}}</pre>-->
    </div>
</template>

<script>
import VuePagination from "../../Pagination";
import {mapState} from "vuex";
import AddAccountModal from "./AddAccountModal";
import AddAccountDetailsModal from "./AddAccountDetailsModal";
import {canViewSuperAdmin} from "../../../util/Permissions";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
import {domain} from "../../../util/Constants";

export default {
    components: {
        DeleteConfirmModal,
        AddAccountDetailsModal,
        AddAccountModal,
        VuePagination
    },
    name: "account",
    created() {
        this.$store.dispatch("Account/getPaymentAccount");
    },
    data() {
        return {
            search: {
                account: ""
            },
            delete_details_id: "",
            page: 1,
            event_submit: false,
            delete_id: '',
        }
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            PaymentAccountTable: state => {
                return state.Account.paymentAccountTable;
            },
            dataPaginate: state => {
                return state.Account.dataPaginate
            }
        })
    },
    methods: {
        printReportExcel() {
            window.open(domain + '/excel-account-pay' + "?account=" + this.search.account);
        },
        showAddAccountModal() {
            this.$refs.add_account.show();
        },
        hideAddAccountModal() {
            this.$refs.add_account.hide();
        },
        showDeleteAccountModal(id) {
            this.delete_id = id;
            this.$refs.delete_account.show();
        },
        hideDeleteAccountModal() {
            this.$refs.delete_account.hide();
        },
        showDeleteDetailsModal(id) {
            this.delete_details_id = id;
            this.$refs.delete_account_details.show();
        },
        hideDeleteDetailsModal() {
            this.$refs.delete_account_details.hide();
        },
        saveBillingPaymentForm(form) {
            if (form) {
                //console.log(form)
                this.$store.dispatch("Account/savePaymentAccount", {
                    id: form.id,
                    data: form
                }).then(() => {
                    this.$store.dispatch("Account/getPaymentAccount");
                })
            }
            this.hideAddAccountModal();
        },
        showBillingPaymentForm(id) {
            this.showAddAccountModal();
            this.$store.dispatch("Account/getPaymentAccountById", id)
        },
        searchPaymentAccount() {
            this.event_submit = true;
            this.$store.dispatch("Account/search", {
                page: this.page,
                data: this.search
            })
        },
        clearFormBeforeModal() {
            this.showAddAccountModal();
            this.$store.dispatch("Account/clearData", 'cost');
        },
        deletePaymentAccount(value) {
            if (value) {
                this.$store.dispatch("Account/deletePaymentAccount", this.delete_id).then(() => {
                    this.$store.dispatch("Account/getPaymentAccount");
                    alert('ลบรายการสำเร็จ')
                }).catch(() => {
                    alert('ลบรายการไม่สำเร็จ')
                })
            }
            this.hideDeleteAccountModal();
        },

        //Account Details
        showAccountDetailsModal(id, account_id) {
            this.$refs.account_details.show();
            if (id) {
                this.showAccountDetails(id);
            } else {
                this.$store.dispatch("Account/clearAccountDetails", account_id);
            }
        },
        hideAccountDetailsModal() {
            this.$refs.account_details.hide();
        },
        showAccountDetails(id) {
            this.$store.dispatch("Account/getAccountDetailsById", id);
        },
        saveAccountDetails(details) {
            if (details) {
                this.$store.dispatch("Account/saveAccountDetails", {
                    id: details.id,
                    data: details
                }).then(() => {
                    this.$store.dispatch("Account/getPaymentAccount");
                });

            }
            this.hideAccountDetailsModal();
        },

        deleteAccountDetails() {
            this.$store.dispatch("Account/deleteAccountDetails", this.delete_details_id).then(() => {
                this.$store.dispatch("Account/getPaymentAccount");
                this.hideDeleteDetailsModal();
                alert('ลบรายการสำเร็จ');
            }).catch(err => {
                alert('ลบรายการไม่สำเร็จ')
            });
        },
        getPage() {
            this.page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.searchPaymentAccount();
            } else {
                this.$store.dispatch("Account/getPaymentAccount", this.page);
            }
        }

    }
}
</script>

<style scoped>
.heading-table {
    background-color: #CDC4C4;
}
</style>
